module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iV2Fyc3R3YV8xIiBkYXRhLW5hbWU9IldhcnN0d2EgMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgNTkuMTcgMjguMTkiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDpub25lO3N0cm9rZTojMWExYTFhO3N0cm9rZS1taXRlcmxpbWl0OjEwO3N0cm9rZS13aWR0aDo1cHg7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5TY3JvbGwgZG93bl9TVkc8L3RpdGxlPjxwb2x5bGluZSBjbGFzcz0iY2xzLTEiIHBvaW50cz0iMS41NSAxLjk2IDMwLjU1IDI0Ljk2IDU3LjU1IDEuOTYiLz48L3N2Zz4NCg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/ico_scroll-down-dark.svg
// module id = ZT8b
// module chunks = 2